const gaussianFragmentShader = /* glsl */ `
precision highp float;

varying vec2 vGaussianPosition;
varying vec3 vColor;
varying float vOpacity;

uniform float globalOpacity;
uniform float alphaCutoff;

void main() {
    float radiusSquared = dot(vGaussianPosition, vGaussianPosition);
    float gaussian = exp(-0.5 * radiusSquared);
    float alpha = gaussian * vOpacity * globalOpacity;

    if (alpha < alphaCutoff) {
        discard;
    }

    gl_FragColor = vec4(vColor, alpha);
}
`;

export default gaussianFragmentShader;
